import React from 'react';

/** Original product mark. Not the GitHub logo. */
const BrandMark = ({ size = 28 }) => (
  <svg
    className="brand-mark"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    aria-hidden="true"
  >
    <rect className="brand-mark-bg" width="32" height="32" rx="9" />
    <circle className="brand-mark-ink" cx="16" cy="13" r="4.2" />
    <path className="brand-mark-ink" d="M13.2 16.2h5.6V24h-2.2v-4.2h-1.2V24h-2.2V16.2z" />
  </svg>
);

export default BrandMark;
